module.exports = __webpack_public_path__ + "static/media/Privacy.4bc867d8.png";